import { CustomersApiService } from '../../common/services/customers.api.service';
import { CustomerModel } from '../../common/models/customer.model';
import REQUEST_STATUS from '../../common/enums/requestStatus';

export default {
  namespaced: true,
  state: {
    status: REQUEST_STATUS.LOADING,
    items: [],
  },
  getters: {
    getCustomers: state => state.items,
    getStatus: state => state.status,
  },
  mutations: {
    SET_ITEMS(state, data) {
      state.items = data;
    },
    FETCH_REQUEST(state) {
      state.status = REQUEST_STATUS.LOADING;
    },
    FETCH_SUCCESS(state) {
      state.status = REQUEST_STATUS.SUCCESS;
    },
    FETCH_FAIL(state) {
      state.status = REQUEST_STATUS.FAIL;
    },
  },
  actions: {
    fetchCustomers({ commit, dispatch }, email) {
      commit('FETCH_REQUEST');

      return CustomersApiService.getAll(builder => {
        builder.whereEquals([CustomerModel.ATTR_EMAIL], email);
      })
        .then(response => {
          commit('SET_ITEMS', response.getItems());
          commit('FETCH_SUCCESS');
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    handleError({ commit }, response) {
      commit('FETCH_FAIL');
      const message = response.getFirstValidationErrorMessage() || response.getMessage();
      this.$app.$alertError(message);
    },
  },
};
